module.exports = __webpack_public_path__ + "static/media/f0_3.d4a8fb8f.png";